var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRezultati(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18125_12210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18125_12210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 15.6345C16.359 15.6345 15.8142 15.4102 15.3655 14.9615C14.9167 14.5128 14.6923 13.968 14.6923 13.327C14.6923 12.686 14.9167 12.1411 15.3655 11.6923C15.8142 11.2436 16.359 11.0193 17 11.0193C17.641 11.0193 18.1858 11.2436 18.6345 11.6923C19.0833 12.1411 19.3077 12.686 19.3077 13.327C19.3077 13.968 19.0833 14.5128 18.6345 14.9615C18.1858 15.4102 17.641 15.6345 17 15.6345ZM11.6923 21.5385V19.3307C11.6923 19.1017 11.7469 18.8863 11.8563 18.6845C11.9656 18.4828 12.1187 18.322 12.3155 18.202C12.7785 17.9243 13.2668 17.6941 13.7803 17.5113C14.2939 17.3286 14.8184 17.1934 15.3538 17.1058L17 19.25L18.627 17.1058C19.1685 17.1934 19.6954 17.3286 20.2078 17.5113C20.7201 17.6941 21.2104 17.9243 21.6788 18.202C21.8763 18.3212 22.0273 18.4804 22.1318 18.6798C22.2362 18.8791 22.2949 19.0897 22.3078 19.3115V21.5385H11.6923ZM8.923 19.3307V20H5.6245C5.171 20 4.78683 19.8418 4.472 19.5255C4.15733 19.2092 4 18.8288 4 18.3845V5.6155C4 5.17117 4.15817 4.79083 4.4745 4.4745C4.79083 4.15817 5.17117 4 5.6155 4H18.3845C18.8288 4 19.2092 4.15817 19.5255 4.4745C19.8418 4.79083 20 5.17117 20 5.6155V9.30775C19.573 8.96542 19.1082 8.7035 18.6058 8.522C18.1033 8.34067 17.568 8.25 17 8.25C16.9103 8.25 16.827 8.25317 16.75 8.2595C16.673 8.266 16.5897 8.27567 16.5 8.2885V7.73075H7.5V8.73075H14.923C14.3077 8.99742 13.7738 9.36792 13.3212 9.84225C12.8686 10.3166 12.5186 10.8692 12.2713 11.5H7.5V12.5H12.0192C11.9551 12.9142 11.9381 13.3296 11.9683 13.7463C11.9984 14.1629 12.0802 14.5744 12.2135 14.9808C12.0982 15.0321 11.986 15.0802 11.877 15.125C11.768 15.1698 11.6622 15.2179 11.5595 15.2692H7.5V16.2692H10.2963C9.85908 16.6526 9.52092 17.1151 9.28175 17.6568C9.04258 18.1984 8.923 18.7564 8.923 19.3307Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRezultati);
export default __webpack_public_path__ + "static/media/rezultati.a4c5b413f164a8e1fc5e9f8202e4e67a.svg";
export { ForwardRef as ReactComponent };